import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';

interface ILoadingProps {
    message?: string;
}

export const Loading: React.FC<ILoadingProps> = ({ message }) => {
    return (
        <Dialog
            open={true}
            className='loading-dialog'
            aria-labelledby='loading'>
            <DialogContent>
                <div className='text-center'>
                    <CircularProgress />
                </div>
                {message && <div className='loading'>{message}</div>}
            </DialogContent>
        </Dialog>
    );
};

export default Loading;
